import React, { FC } from "react";
import { Patient } from "@models/patient";
import { Avatar, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import styled from "@emotion/styled";
import { ExpandMore } from "@mui/icons-material";

const Item = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  max-width: 100%;
  overflow: hidden;
  margin-right: 4px;
  white-space: nowrap;
`;

const ReadOnlyPatient = styled.div`
  display: flex;
`;

interface PatientSelectProps {
  patients: Patient[];
  selectedPatientId: string | null;
  onChange: (patientId: string | null) => void;
}

const getPatientName = (patient: Patient) => {
  if (!patient) {
    return "";
  }
  let name = `${patient.firstName || ""} ${patient.lastName || ""}`;
  if (!name) {
    name = patient.nickname;
  }

  return name;
};

const PatientSelect: FC<PatientSelectProps> = ({
  patients,
  selectedPatientId,
  onChange,
}) => {
  const onSelectPatient = (event: SelectChangeEvent) => {
    onChange((event.target.value as string) || null);
  };

  if (!patients?.length) {
    return null;
  }

  return (
    <div>
      {patients.length > 1 ? (
        <Select
          defaultValue=""
          size="small"
          value={selectedPatientId || undefined}
          onChange={onSelectPatient}
          sx={{ minWidth: "150px" }}
          fullWidth
          variant="standard"
          disableUnderline={true}
          IconComponent={(props) => <ExpandMore {...props} />}
        >
          {patients.map((patient) => {
            const name = getPatientName(patient);
            return (
              <MenuItem key={patient.id} value={patient.id}>
                <Item>
                  <Avatar
                    sx={{ width: 36, height: 36 }}
                    alt={name}
                    src={patient.avatarUrl}
                  />
                  <span>{name}</span>
                </Item>
              </MenuItem>
            );
          })}
        </Select>
      ) : (
        <ReadOnlyPatient>
          <Item>
            <Avatar
              sx={{ width: 36, height: 36 }}
              alt={getPatientName(patients[0])}
              src={patients[0].avatarUrl}
            />
            {getPatientName(patients[0])}
          </Item>
        </ReadOnlyPatient>
      )}
    </div>
  );
};

export default PatientSelect;
